// AUTO-GENERATED by gcp_backend/build_bhilwara_defects.py
// Re-run after a new Label Studio export to refresh the map.
// Frames: 1034   Survey: 2026-04-16T10:46:00.000Z

const BHILWARA_DEFECT_POINTS = [
  {
    "latitude": 25.3716319,
    "longitude": 74.6248039,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000014.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000014.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000014",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000014",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3715757,
    "longitude": 74.6248249,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000015.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000015.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000015",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000015",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.371507,
    "longitude": 74.6248486,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000016.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000016.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000016",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000016",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3714469,
    "longitude": 74.6248684,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000017.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000017.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000017",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000017",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3713869,
    "longitude": 74.6248887,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000018.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000018.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000018",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000018",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3713178,
    "longitude": 74.6249123,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000019.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000019.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000019",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000019",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.371258,
    "longitude": 74.6249331,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000020.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000020.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000020",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000020",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3712074,
    "longitude": 74.6249513,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000021.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000021.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000021",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000021",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3711658,
    "longitude": 74.6249666,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000022.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000022.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000022",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000022",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3711362,
    "longitude": 74.6249779,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000023.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000023.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000023",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000023",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3710887,
    "longitude": 74.6249959,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000024.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000024.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000024",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000024",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3710563,
    "longitude": 74.6250081,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000025.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000025.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000025",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000025",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3710267,
    "longitude": 74.6250187,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000026.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000026.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000026",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000026",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3709761,
    "longitude": 74.6250367,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000027.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000027.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000027",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000027",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3709282,
    "longitude": 74.6250537,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000028.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000028.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000028",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000028",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3708864,
    "longitude": 74.6250682,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000029.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000029.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000029",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000029",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3708272,
    "longitude": 74.6250901,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000030.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000030.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000030",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000030",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3707793,
    "longitude": 74.6251077,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000031.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000031.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000031",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000031",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3707287,
    "longitude": 74.6251258,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000032.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000032.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000032",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000032",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3706875,
    "longitude": 74.6251415,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000033.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000033.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000033",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000033",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3706397,
    "longitude": 74.6251592,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000034.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000034.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000034",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000034",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3705984,
    "longitude": 74.6251749,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000035.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000035.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000035",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000035",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3705503,
    "longitude": 74.6251912,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000036.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000036.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000036",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000036",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3705086,
    "longitude": 74.6252046,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000037.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000037.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000037",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000037",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3704692,
    "longitude": 74.6252169,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000038.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000038.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000038",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000038",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3704296,
    "longitude": 74.6252284,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000039.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000039.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000039",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000039",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3703784,
    "longitude": 74.6252439,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000040.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000040.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000040",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000040",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3703298,
    "longitude": 74.6252592,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000041.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000041.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000041",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000041",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3702788,
    "longitude": 74.6252753,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000042.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000042.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000042",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000042",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3702276,
    "longitude": 74.625291,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000043.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000043.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000043",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000043",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3701767,
    "longitude": 74.6253073,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000044.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000044.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000044",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000044",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3701252,
    "longitude": 74.6253237,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000045.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000045.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000045",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000045",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3700656,
    "longitude": 74.6253454,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000046.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000046.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000046",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000046",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3700152,
    "longitude": 74.625364,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Potholes",
        "severity": "low"
      },
      {
        "label": "Potholes",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000047.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000047.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000047",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000047",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3699648,
    "longitude": 74.6253824,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000048.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000048.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000048",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000048",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3699051,
    "longitude": 74.6254041,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000049.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000049.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000049",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000049",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3698546,
    "longitude": 74.6254232,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000050.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000050.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000050",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000050",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3697956,
    "longitude": 74.6254463,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000051.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000051.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000051",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000051",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3697455,
    "longitude": 74.6254656,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Potholes",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Potholes",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000052.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000052.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000052",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000052",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3696954,
    "longitude": 74.6254832,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000053.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000053.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000053",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000053",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3696354,
    "longitude": 74.6255044,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000054.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000054.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000054",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000054",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3695854,
    "longitude": 74.6255225,
    "inference_info": [
      {
        "label": "Potholes",
        "severity": "low"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000055.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000055.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000055",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000055",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3695436,
    "longitude": 74.6255361,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000056.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000056.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000056",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000056",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3694952,
    "longitude": 74.6255526,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000057.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000057.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000057",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000057",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3694538,
    "longitude": 74.6255656,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000058.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000058.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000058",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000058",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3694142,
    "longitude": 74.6255786,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000059.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000059.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000059",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000059",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3693635,
    "longitude": 74.6255952,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000060.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000060.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000060",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000060",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3693243,
    "longitude": 74.6256077,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000061.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000061.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000061",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000061",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3692732,
    "longitude": 74.6256237,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000062.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000062.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000062",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000062",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3691228,
    "longitude": 74.6256767,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000065.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000065.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000065",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000065",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3690635,
    "longitude": 74.6257004,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000066.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000066.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000066",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000066",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3690137,
    "longitude": 74.6257185,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000067.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000067.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000067",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000067",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.368963,
    "longitude": 74.6257374,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000068.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000068.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000068",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000068",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3689038,
    "longitude": 74.6257598,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000069.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000069.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000069",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000069",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3688536,
    "longitude": 74.6257781,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000070.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000070.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000070",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000070",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3687433,
    "longitude": 74.62582,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000071.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000071.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000071",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000071",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3686844,
    "longitude": 74.6258446,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000072.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000072.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000072",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000072",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3686384,
    "longitude": 74.625865,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000073.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000073.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000073",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000073",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3685794,
    "longitude": 74.6258879,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000074.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000074.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000074",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000074",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3685289,
    "longitude": 74.6259062,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000075.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000075.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000075",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000075",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3684787,
    "longitude": 74.6259258,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000076.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000076.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000076",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000076",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3684286,
    "longitude": 74.6259458,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000077.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000077.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000077",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000077",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3683816,
    "longitude": 74.6259649,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000078.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000078.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000078",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000078",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.368332,
    "longitude": 74.6259857,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000079.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000079.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000079",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000079",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3682822,
    "longitude": 74.6260066,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000080.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000080.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000080",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000080",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3682323,
    "longitude": 74.6260268,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000081.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000081.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000081",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000081",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3681349,
    "longitude": 74.6260655,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000082.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000082.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000082",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000082",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3680928,
    "longitude": 74.62608,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000083.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000083.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000083",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000083",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.368042,
    "longitude": 74.6260972,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000084.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000084.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000084",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000084",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.367991,
    "longitude": 74.626114,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000085.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000085.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000085",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000085",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3679311,
    "longitude": 74.626134,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000086.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000086.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000086",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000086",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3678895,
    "longitude": 74.6261481,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000087.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000087.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000087",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000087",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3678386,
    "longitude": 74.626165,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000088.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000088.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000088",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000088",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.367788,
    "longitude": 74.6261827,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000089.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000089.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000089",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000089",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3677397,
    "longitude": 74.6261991,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000090.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000090.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000090",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000090",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.367698,
    "longitude": 74.6262119,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000091.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000091.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000091",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000091",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3676378,
    "longitude": 74.6262325,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000092.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000092.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000092",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000092",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3675962,
    "longitude": 74.6262482,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000093.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000093.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000093",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000093",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3675461,
    "longitude": 74.626268,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000094.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000094.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000094",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000094",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3674961,
    "longitude": 74.626288,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000095.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000095.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000095",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000095",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3674459,
    "longitude": 74.6263068,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000096.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000096.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000096",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000096",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.367348,
    "longitude": 74.6263434,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000097.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000097.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000097",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000097",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3672973,
    "longitude": 74.6263623,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000098.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000098.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000098",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000098",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3672478,
    "longitude": 74.6263836,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000099.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000099.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000099",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000099",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.367198,
    "longitude": 74.6264037,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000100.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000100.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000100",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000100",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3671506,
    "longitude": 74.6264221,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000101.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000101.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000101",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000101",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3671004,
    "longitude": 74.6264414,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000102.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000102.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000102",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000102",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3670619,
    "longitude": 74.6264562,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000103.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000103.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000103",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000103",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3670119,
    "longitude": 74.6264759,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000104.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000104.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000104",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000104",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3669651,
    "longitude": 74.6264949,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000105.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000105.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000105",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000105",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3669153,
    "longitude": 74.6265157,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000106.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000106.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000106",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000106",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3668648,
    "longitude": 74.6265354,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000107.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000107.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000107",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000107",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3668177,
    "longitude": 74.6265538,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000108.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000108.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000108",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000108",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3667581,
    "longitude": 74.6265769,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000109.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000109.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000109",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000109",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3667079,
    "longitude": 74.6265955,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000110.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000110.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000110",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000110",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3662371,
    "longitude": 74.6267666,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000118.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000118.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000118",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000118",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3662071,
    "longitude": 74.6267764,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000119.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000119.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000119",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000119",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3661559,
    "longitude": 74.6267929,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000120.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000120.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000120",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000120",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3661074,
    "longitude": 74.6268082,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000121.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000121.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000121",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000121",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3660749,
    "longitude": 74.6268187,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000122.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000122.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000122",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000122",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3660445,
    "longitude": 74.6268285,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000123.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000123.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000123",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000123",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3660142,
    "longitude": 74.6268374,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000124.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000124.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000124",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000124",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3659744,
    "longitude": 74.6268491,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000125.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000125.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000125",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000125",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3659441,
    "longitude": 74.6268577,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000126.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000126.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000126",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000126",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3658722,
    "longitude": 74.6268789,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000127.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000127.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000127",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000127",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3658,
    "longitude": 74.6269,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000128.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000128.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000128",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000128",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.36577,
    "longitude": 74.6269102,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000129.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000129.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000129",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000129",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3657375,
    "longitude": 74.6269212,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000130.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000130.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000130",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000130",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3656868,
    "longitude": 74.6269387,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000131.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000131.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000131",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000131",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3656453,
    "longitude": 74.6269522,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000132.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000132.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000132",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000132",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3655968,
    "longitude": 74.626968,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000133.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000133.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000133",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000133",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3655459,
    "longitude": 74.6269848,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000134.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000134.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000134",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000134",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3654558,
    "longitude": 74.6270138,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000135.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000135.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000135",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000135",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3654139,
    "longitude": 74.6270279,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000136.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000136.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000136",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000136",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3653715,
    "longitude": 74.6270426,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000137.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000137.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000137",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000137",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3652738,
    "longitude": 74.6270796,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000139.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000139.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000139",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000139",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3652247,
    "longitude": 74.6270968,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000140.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000140.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000140",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000140",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3645815,
    "longitude": 74.6273382,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000153.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000153.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000153",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000153",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3645412,
    "longitude": 74.6273574,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000154.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000154.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000154",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000154",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3645009,
    "longitude": 74.6273766,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000155.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000155.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000155",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000155",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3643493,
    "longitude": 74.6274574,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000157.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000157.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000157",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000157",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3642991,
    "longitude": 74.6274852,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000158.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000158.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000158",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000158",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3642519,
    "longitude": 74.6275084,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000159.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000159.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000159",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000159",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3642144,
    "longitude": 74.6275263,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000160.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000160.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000160",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000160",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3641576,
    "longitude": 74.6275534,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000161.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000161.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000161",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000161",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3641169,
    "longitude": 74.6275713,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000162.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000162.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000162",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000162",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3640761,
    "longitude": 74.6275904,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "high"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/000163.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000163.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000163",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000163",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3640371,
    "longitude": 74.6276152,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000164.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000164.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000164",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000164",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3639895,
    "longitude": 74.6276491,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000165.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000165.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000165",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000165",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3639511,
    "longitude": 74.6276722,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000166.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000166.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000166",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000166",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3639128,
    "longitude": 74.6276956,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000167.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000167.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000167",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000167",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3638325,
    "longitude": 74.6277449,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Rutting",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000168.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000168.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000168",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000168",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3637909,
    "longitude": 74.6277716,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000169.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000169.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000169",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000169",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3637492,
    "longitude": 74.6277983,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000170.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000170.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000170",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000170",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3636951,
    "longitude": 74.6278301,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000171.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000171.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000171",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000171",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3636411,
    "longitude": 74.6278628,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000172.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000172.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000172",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000172",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3635879,
    "longitude": 74.6278965,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000173.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000173.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000173",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000173",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3628925,
    "longitude": 74.62841,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000187.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000187.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000187",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000187",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.362843,
    "longitude": 74.62844,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000188.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000188.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000188",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000188",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3689148,
    "longitude": 74.6257556,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000246.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000246.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000246",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000246",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3689713,
    "longitude": 74.6257343,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000247.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000247.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000247",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000247",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3690398,
    "longitude": 74.6257092,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000248.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000248.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000248",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000248",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3691076,
    "longitude": 74.6256826,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000249.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000249.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000249",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000249",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3691697,
    "longitude": 74.6256589,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000250.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000250.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000250",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000250",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3692386,
    "longitude": 74.6256346,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000251.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000251.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000251",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000251",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3693081,
    "longitude": 74.6256127,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000252.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000252.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000252",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000252",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3694283,
    "longitude": 74.6255739,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000254.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000254.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000254",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000254",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3694886,
    "longitude": 74.6255547,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000255.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000255.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000255",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000255",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3695993,
    "longitude": 74.6255175,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000257.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000257.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000257",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000257",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3696588,
    "longitude": 74.6254959,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000258.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000258.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000258",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000258",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3697188,
    "longitude": 74.6254754,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000259.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000259.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000259",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000259",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3697751,
    "longitude": 74.6254543,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000260.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000260.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000260",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000260",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3698369,
    "longitude": 74.6254302,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000261.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000261.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000261",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000261",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3700332,
    "longitude": 74.6253574,
    "inference_info": [
      {
        "label": "Shoulder - Unevenness",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000264.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000264.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000264",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000264",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3700927,
    "longitude": 74.6253355,
    "inference_info": [
      {
        "label": "Pavement Damage",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000265.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000265.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000265",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000265",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3701535,
    "longitude": 74.6253146,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000266.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000266.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000266",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000266",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3702136,
    "longitude": 74.6252955,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000267.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000267.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000267",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000267",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3705337,
    "longitude": 74.6251968,
    "inference_info": [
      {
        "label": "Median Separator Paint Faded",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000272.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000272.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000272",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000272",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3705845,
    "longitude": 74.6251798,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000273.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000273.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000273",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000273",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3706459,
    "longitude": 74.6251568,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000274.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000274.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000274",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000274",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3707052,
    "longitude": 74.6251348,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000275.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000275.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000275",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000275",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3707587,
    "longitude": 74.6251152,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000276.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000276.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000276",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000276",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.370809,
    "longitude": 74.6250963,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000277.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000277.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000277",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000277",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3708505,
    "longitude": 74.6250818,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000278.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000278.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000278",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000278",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3709074,
    "longitude": 74.6250609,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000279.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000279.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000279",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000279",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3709399,
    "longitude": 74.6250497,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000280.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000280.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000280",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000280",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3709878,
    "longitude": 74.6250326,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Potholes",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000281.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000281.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000281",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000281",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3711894,
    "longitude": 74.6249579,
    "inference_info": [
      {
        "label": "Potholes",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000285.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000285.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000285",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000285",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3712489,
    "longitude": 74.6249363,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000286.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000286.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000286",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000286",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3713087,
    "longitude": 74.6249155,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000287.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000287.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000287",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000287",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3713686,
    "longitude": 74.6248949,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000288.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000288.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000288",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000288",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3716992,
    "longitude": 74.6247776,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000293.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000293.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000293",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000293",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3717609,
    "longitude": 74.6247527,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000294.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000294.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000294",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000294",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3718271,
    "longitude": 74.6247225,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000295.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000295.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000295",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000295",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3718872,
    "longitude": 74.6246937,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000296.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000296.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000296",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000296",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3719455,
    "longitude": 74.6246612,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000297.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000297.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000297",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000297",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3720058,
    "longitude": 74.6246228,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000298.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000298.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000298",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000298",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3720648,
    "longitude": 74.624581,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000299.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000299.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000299",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000299",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3721232,
    "longitude": 74.6245389,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000300.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000300.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000300",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000300",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3721812,
    "longitude": 74.6244955,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000301.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000301.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000301",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000301",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3722432,
    "longitude": 74.6244489,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000302.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000302.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000302",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000302",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3615841,
    "longitude": 74.6294445,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Work Zone - Inadequate Barricading",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000321.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000321.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000321",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000321",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3615324,
    "longitude": 74.6294813,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Work Zone - Inadequate Barricading",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000322.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000322.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000322",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000322",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3614695,
    "longitude": 74.6295263,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000323.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000323.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000323",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000323",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3614107,
    "longitude": 74.6295684,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000324.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000324.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000324",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000324",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3613479,
    "longitude": 74.6296135,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000325.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000325.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000325",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000325",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3612967,
    "longitude": 74.6296511,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Work Zone - Inadequate Barricading",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000326.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000326.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000326",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000326",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.361238,
    "longitude": 74.6296937,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000327.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000327.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000327",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000327",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3611862,
    "longitude": 74.6297307,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000328.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000328.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000328",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000328",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3611295,
    "longitude": 74.6297739,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000329.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000329.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000329",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000329",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3610797,
    "longitude": 74.6298153,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000330.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000330.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000330",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000330",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3609736,
    "longitude": 74.6298949,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000332.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000332.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000332",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000332",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3592909,
    "longitude": 74.6299807,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000370.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000370.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000370",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000370",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.359253,
    "longitude": 74.629977,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000371.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000371.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000371",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000371",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.359203,
    "longitude": 74.6299688,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000372.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000372.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000372",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000372",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3591626,
    "longitude": 74.6299618,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000373.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000373.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000373",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000373",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3591126,
    "longitude": 74.6299527,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000374.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000374.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000374",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000374",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3590724,
    "longitude": 74.6299451,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000375.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000375.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000375",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000375",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3590224,
    "longitude": 74.6299351,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000376.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000376.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000376",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000376",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3589722,
    "longitude": 74.6299257,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000377.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000377.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000377",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000377",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3589219,
    "longitude": 74.6299167,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000378.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000378.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000378",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000378",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3588718,
    "longitude": 74.6299078,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000379.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000379.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000379",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000379",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3588217,
    "longitude": 74.6298986,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000380.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000380.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000380",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000380",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3587717,
    "longitude": 74.6298892,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000381.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000381.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000381",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000381",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3587201,
    "longitude": 74.6298795,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000382.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000382.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000382",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000382",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3586603,
    "longitude": 74.6298683,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000383.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000383.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000383",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000383",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3586102,
    "longitude": 74.6298588,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000384.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000384.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000384",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000384",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3585602,
    "longitude": 74.6298487,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000385.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000385.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000385",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000385",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3585004,
    "longitude": 74.6298373,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000386.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000386.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000386",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000386",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3584503,
    "longitude": 74.6298278,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000387.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000387.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000387",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000387",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3584002,
    "longitude": 74.6298186,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000388.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000388.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000388",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000388",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3583416,
    "longitude": 74.6298084,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000389.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000389.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000389",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000389",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3582817,
    "longitude": 74.629798,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000390.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000390.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000390",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000390",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3582215,
    "longitude": 74.6297883,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000391.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000391.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000391",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000391",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3581622,
    "longitude": 74.6297801,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000392.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000392.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000392",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000392",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3581118,
    "longitude": 74.6297734,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000393.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000393.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000393",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000393",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3580514,
    "longitude": 74.6297656,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000394.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000394.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000394",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000394",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3580008,
    "longitude": 74.6297598,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000395.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000395.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000395",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000395",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3579406,
    "longitude": 74.629757,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000396.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000396.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000396",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000396",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3578906,
    "longitude": 74.6297555,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000397.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000397.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000397",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000397",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3578286,
    "longitude": 74.6297586,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000398.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000398.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000398",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000398",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3577769,
    "longitude": 74.6297652,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000399.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000399.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000399",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000399",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3577256,
    "longitude": 74.6297743,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000400.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000400.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000400",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000400",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3576752,
    "longitude": 74.6297849,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000401.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000401.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000401",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000401",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.357616,
    "longitude": 74.6297986,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000402.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000402.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000402",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000402",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3575662,
    "longitude": 74.6298106,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000403.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000403.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000403",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000403",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3575146,
    "longitude": 74.6298233,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000404.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000404.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000404",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000404",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3574648,
    "longitude": 74.6298356,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000405.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000405.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000405",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000405",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3574154,
    "longitude": 74.6298484,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000406.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000406.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000406",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000406",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3573637,
    "longitude": 74.6298624,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000407.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000407.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000407",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000407",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3568842,
    "longitude": 74.6299823,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000417.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000417.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000417",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000417",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3568347,
    "longitude": 74.629995,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000418.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000418.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000418",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000418",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3566932,
    "longitude": 74.6300326,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000421.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000421.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000421",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000421",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3566443,
    "longitude": 74.6300475,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000422.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000422.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000422",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000422",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3565958,
    "longitude": 74.6300624,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000423.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000423.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000423",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000423",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3565555,
    "longitude": 74.6300747,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000424.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000424.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000424",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000424",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.356505,
    "longitude": 74.630093,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000425.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000425.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000425",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000425",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3564662,
    "longitude": 74.6301053,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000426.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000426.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000426",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000426",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3564177,
    "longitude": 74.6301197,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000427.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000427.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000427",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000427",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3563779,
    "longitude": 74.6301307,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000428.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000428.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000428",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000428",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3563267,
    "longitude": 74.6301427,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000429.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000429.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000429",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000429",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3562866,
    "longitude": 74.6301519,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000430.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000430.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000430",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000430",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3562465,
    "longitude": 74.6301611,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000431.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000431.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000431",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000431",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3562061,
    "longitude": 74.6301711,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000432.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000432.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000432",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000432",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3552687,
    "longitude": 74.6304112,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000456.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000456.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000456",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000456",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3551976,
    "longitude": 74.6305437,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000460.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000460.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000460",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000460",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35516,
    "longitude": 74.6305503,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000461.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000461.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000461",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000461",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3551211,
    "longitude": 74.630557,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000462.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000462.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000462",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000462",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3550824,
    "longitude": 74.6305647,
    "inference_info": [
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000463.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000463.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000463",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000463",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.355032,
    "longitude": 74.6305743,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000464.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000464.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000464",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000464",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3550026,
    "longitude": 74.6305792,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Signage - Poor Visibility (Day)",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000465.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000465.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000465",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000465",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3549233,
    "longitude": 74.6305944,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000466.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000466.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000466",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000466",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3548829,
    "longitude": 74.6306012,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000467.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000467.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000467",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000467",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3548523,
    "longitude": 74.6306064,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000468.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000468.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000468",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000468",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3547923,
    "longitude": 74.6306167,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000469.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000469.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000469",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000469",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3547519,
    "longitude": 74.6306235,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000470.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000470.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000470",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000470",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3547127,
    "longitude": 74.63063,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000471.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000471.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000471",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000471",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3546333,
    "longitude": 74.6306434,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000472.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000472.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000472",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000472",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3545548,
    "longitude": 74.6306587,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000474.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000474.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000474",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000474",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3544639,
    "longitude": 74.6306763,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000475.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000475.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000475",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000475",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3544138,
    "longitude": 74.6306854,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000476.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000476.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000476",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000476",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3543639,
    "longitude": 74.6306948,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000477.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000477.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000477",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000477",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3542738,
    "longitude": 74.6307123,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000478.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000478.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000478",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000478",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3542239,
    "longitude": 74.6307228,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000479.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000479.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000479",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000479",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3541833,
    "longitude": 74.6307307,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000480.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000480.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000480",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000480",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.354083,
    "longitude": 74.6307508,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000481.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000481.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000481",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000481",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3540328,
    "longitude": 74.6307595,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000482.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000482.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000482",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000482",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3539833,
    "longitude": 74.6307696,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000483.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000483.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000483",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000483",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3537846,
    "longitude": 74.6308093,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000486.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000486.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000486",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000486",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3536844,
    "longitude": 74.6308284,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000487.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000487.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000487",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000487",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3536345,
    "longitude": 74.630838,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000488.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000488.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000488",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000488",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3535843,
    "longitude": 74.6308479,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000489.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000489.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000489",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000489",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3534846,
    "longitude": 74.6308673,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000490.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000490.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000490",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000490",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3534345,
    "longitude": 74.6308775,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000491.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000491.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000491",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000491",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.353383,
    "longitude": 74.6308878,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000492.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000492.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000492",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000492",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.353304,
    "longitude": 74.6309039,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000493.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000493.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000493",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000493",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3532733,
    "longitude": 74.6309101,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000494.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000494.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000494",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000494",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3532441,
    "longitude": 74.6309159,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000495.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000495.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000495",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000495",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3531843,
    "longitude": 74.6309275,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000496.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000496.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000496",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000496",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3531537,
    "longitude": 74.6309334,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000497.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000497.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000497",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000497",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3531247,
    "longitude": 74.6309391,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000498.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000498.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000498",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000498",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3530734,
    "longitude": 74.6309492,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000499.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000499.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000499",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000499",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.353013,
    "longitude": 74.6309578,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000500.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000500.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000500",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000500",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3529824,
    "longitude": 74.6309618,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000501.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000501.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000501",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000501",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3529417,
    "longitude": 74.6309659,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000502.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000502.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000502",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000502",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.352911,
    "longitude": 74.6309682,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000503.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000503.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000503",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000503",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3528395,
    "longitude": 74.6309694,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000504.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000504.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000504",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000504",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.352651,
    "longitude": 74.6309203,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000506.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000506.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000506",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000506",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3526227,
    "longitude": 74.6309037,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000507.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000507.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000507",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000507",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3525851,
    "longitude": 74.6308784,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000508.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000508.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000508",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000508",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3525245,
    "longitude": 74.6308278,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000509.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000509.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000509",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000509",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3525049,
    "longitude": 74.6307819,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000510.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000510.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000510",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000510",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3524716,
    "longitude": 74.6307574,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000511.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000511.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000511",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000511",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3524009,
    "longitude": 74.6306986,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000512.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000512.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000512",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000512",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3523628,
    "longitude": 74.630666,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000513.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000513.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000513",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000513",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.352331,
    "longitude": 74.6306386,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000514.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000514.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000514",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000514",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3522478,
    "longitude": 74.630583,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000515.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000515.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000515",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000515",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3522164,
    "longitude": 74.6305549,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000516.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000516.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000516",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000516",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3521785,
    "longitude": 74.6305221,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000517.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000517.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000517",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000517",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3521173,
    "longitude": 74.6304744,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000518.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000518.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000518",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000518",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3520772,
    "longitude": 74.6304447,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000519.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000519.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000519",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000519",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3520371,
    "longitude": 74.6304156,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000520.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000520.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000520",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000520",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3519562,
    "longitude": 74.6303694,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000521.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000521.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000521",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000521",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3519161,
    "longitude": 74.6303504,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000522.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000522.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000522",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000522",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3518671,
    "longitude": 74.6303301,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000523.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000523.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000523",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000523",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.351819,
    "longitude": 74.6303155,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000524.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000524.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000524",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000524",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3517694,
    "longitude": 74.6303057,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000525.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000525.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000525",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000525",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35172,
    "longitude": 74.6302999,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000526.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000526.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000526",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000526",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3516599,
    "longitude": 74.6302983,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000527.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000527.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000527",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000527",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3515498,
    "longitude": 74.6303061,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000528.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000528.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000528",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000528",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3514895,
    "longitude": 74.63031,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000529.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000529.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000529",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000529",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3514297,
    "longitude": 74.6303137,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000530.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000530.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000530",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000530",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3513096,
    "longitude": 74.6303236,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000531.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000531.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000531",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000531",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3512493,
    "longitude": 74.6303282,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Potholes",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000532.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000532.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000532",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000532",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3511895,
    "longitude": 74.6303331,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000533.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000533.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000533",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000533",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3510596,
    "longitude": 74.6303457,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000534.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000534.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000534",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000534",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3510001,
    "longitude": 74.6303523,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000535.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000535.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000535",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000535",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3509398,
    "longitude": 74.6303571,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000536.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000536.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000536",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000536",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3508199,
    "longitude": 74.6303683,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000537.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000537.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000537",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000537",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3507702,
    "longitude": 74.6303729,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000538.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000538.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000538",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000538",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3507099,
    "longitude": 74.6303785,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000539.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000539.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000539",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000539",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3506098,
    "longitude": 74.6303862,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000540.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000540.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000540",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000540",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35056,
    "longitude": 74.6303899,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000541.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000541.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000541",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000541",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3505101,
    "longitude": 74.630393,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000542.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000542.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000542",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000542",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3504106,
    "longitude": 74.6303987,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000543.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000543.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000543",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000543",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3503604,
    "longitude": 74.6304024,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000544.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000544.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000544",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000544",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3503204,
    "longitude": 74.6304039,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000545.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000545.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000545",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000545",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3502392,
    "longitude": 74.6304009,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000546.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000546.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000546",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000546",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3501492,
    "longitude": 74.6303941,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000547.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000547.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000547",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000547",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3501088,
    "longitude": 74.6303914,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000548.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000548.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000548",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000548",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3500099,
    "longitude": 74.6303877,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000549.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000549.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000549",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000549",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3499601,
    "longitude": 74.6303872,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000550.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000550.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000550",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000550",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34987,
    "longitude": 74.63039,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000551.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000551.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000551",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000551",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3497802,
    "longitude": 74.6303945,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000552.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000552.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000552",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000552",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34969,
    "longitude": 74.6303997,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000553.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000553.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000553",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000553",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3496402,
    "longitude": 74.6304031,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000554.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000554.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000554",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000554",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3496003,
    "longitude": 74.6304058,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000555.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000555.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000555",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000555",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3495101,
    "longitude": 74.6304113,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000556.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000556.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000556",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000556",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3494602,
    "longitude": 74.6304144,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000557.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000557.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000557",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000557",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3494103,
    "longitude": 74.630417,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000558.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000558.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000558",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000558",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3493201,
    "longitude": 74.6304214,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000559.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000559.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000559",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000559",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3492201,
    "longitude": 74.6304249,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000560.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000560.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000560",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000560",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3491201,
    "longitude": 74.6304314,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000561.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000561.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000561",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000561",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3490199,
    "longitude": 74.6304361,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000562.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000562.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000562",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000562",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3489699,
    "longitude": 74.6304388,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000563.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000563.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000563",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000563",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3488697,
    "longitude": 74.6304457,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000564.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000564.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000564",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000564",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3488294,
    "longitude": 74.6304483,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000565.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000565.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000565",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000565",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3487488,
    "longitude": 74.6304551,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000566.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000566.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000566",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000566",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3486694,
    "longitude": 74.6304618,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000567.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000567.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000567",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000567",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3486191,
    "longitude": 74.6304659,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000568.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000568.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000568",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000568",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3485793,
    "longitude": 74.6304692,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000569.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000569.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000569",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000569",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.348489,
    "longitude": 74.6304787,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000570.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000570.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000570",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000570",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.348389,
    "longitude": 74.6304903,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000571.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000571.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000571",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000571",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3483397,
    "longitude": 74.630496,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000572.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000572.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000572",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000572",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3482901,
    "longitude": 74.6305009,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000573.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000573.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000573",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000573",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3482496,
    "longitude": 74.6305043,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000574.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000574.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000574",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000574",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3481503,
    "longitude": 74.6305136,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000575.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000575.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000575",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000575",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3481104,
    "longitude": 74.6305165,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000576.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000576.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000576",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000576",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3480102,
    "longitude": 74.6305236,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000577.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000577.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000577",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000577",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3479598,
    "longitude": 74.6305278,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000578.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000578.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000578",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000578",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3479201,
    "longitude": 74.6305314,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000579.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000579.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000579",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000579",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3478201,
    "longitude": 74.6305416,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000580.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000580.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000580",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000580",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3477598,
    "longitude": 74.6305476,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000581.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000581.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000581",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000581",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3477102,
    "longitude": 74.6305526,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000582.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000582.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000582",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000582",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3476005,
    "longitude": 74.6305649,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000583.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000583.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000583",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000583",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.347551,
    "longitude": 74.6305706,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000584.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000584.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000584",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000584",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3475012,
    "longitude": 74.6305761,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000585.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000585.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000585",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000585",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3473913,
    "longitude": 74.6305864,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000586.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000586.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000586",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000586",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3473315,
    "longitude": 74.6305917,
    "inference_info": [
      {
        "label": "Median Separator Damaged",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000587.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000587.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000587",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000587",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.347282,
    "longitude": 74.6305973,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000588.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000588.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000588",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000588",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3471711,
    "longitude": 74.6306087,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000589.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000589.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000589",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000589",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3471108,
    "longitude": 74.6306131,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000590.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000590.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000590",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000590",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3470603,
    "longitude": 74.6306163,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000591.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000591.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000591",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000591",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3469506,
    "longitude": 74.6306257,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000592.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000592.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000592",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000592",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3468903,
    "longitude": 74.6306335,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000593.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000593.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000593",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000593",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3468407,
    "longitude": 74.6306384,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000594.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000594.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000594",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000594",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3467201,
    "longitude": 74.6306517,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000595.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000595.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000595",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000595",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3466706,
    "longitude": 74.6306571,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000596.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000596.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000596",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000596",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3466103,
    "longitude": 74.6306637,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000597.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000597.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000597",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000597",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3464917,
    "longitude": 74.6306771,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000598.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000598.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000598",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000598",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3464312,
    "longitude": 74.630684,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000599.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000599.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000599",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000599",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3463817,
    "longitude": 74.6306892,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000600.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000600.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000600",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000600",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3462723,
    "longitude": 74.6307018,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000601.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000601.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000601",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000601",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3462218,
    "longitude": 74.6307083,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000602.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000602.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000602",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000602",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3461714,
    "longitude": 74.6307143,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000603.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000603.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000603",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000603",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3461219,
    "longitude": 74.6307202,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000604.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000604.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000604",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000604",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3460717,
    "longitude": 74.6307262,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000605.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000605.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000605",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000605",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3460224,
    "longitude": 74.6307326,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000606.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000606.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000606",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000606",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.345972,
    "longitude": 74.6307392,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000607.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000607.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000607",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000607",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3458652,
    "longitude": 74.6307019,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000608.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000608.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000608",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000608",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3458167,
    "longitude": 74.630715,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000609.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000609.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000609",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000609",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3457691,
    "longitude": 74.6307233,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000610.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000610.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000610",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000610",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3457192,
    "longitude": 74.6307311,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000611.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000611.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000611",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000611",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3456703,
    "longitude": 74.6307355,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000612.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000612.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000612",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000612",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3456295,
    "longitude": 74.6307333,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000613.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000613.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000613",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000613",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3455841,
    "longitude": 74.6307316,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000614.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000614.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000614",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000614",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3454318,
    "longitude": 74.6308071,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000616.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000616.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000616",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000616",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3453317,
    "longitude": 74.6308152,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000618.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000618.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000618",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000618",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3452916,
    "longitude": 74.6308182,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000619.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000619.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000619",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000619",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3452313,
    "longitude": 74.6308225,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000620.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000620.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000620",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000620",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3451915,
    "longitude": 74.6308253,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000621.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000621.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000621",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000621",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3450942,
    "longitude": 74.6308359,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000622.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000622.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000622",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000622",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3448357,
    "longitude": 74.6308045,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000625.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000625.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000625",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000625",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3447944,
    "longitude": 74.6308142,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000626.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000626.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000626",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000626",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.344708,
    "longitude": 74.6308183,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000627.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000627.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000627",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000627",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3440071,
    "longitude": 74.6308832,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000641.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000641.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000641",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000641",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3439464,
    "longitude": 74.6308921,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000642.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000642.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000642",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000642",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3439072,
    "longitude": 74.6308982,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000643.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000643.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000643",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000643",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.343839,
    "longitude": 74.6309076,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000644.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000644.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000644",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000644",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3437986,
    "longitude": 74.6309101,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000645.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000645.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000645",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000645",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3437721,
    "longitude": 74.6309113,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000646.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000646.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000646",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000646",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3434964,
    "longitude": 74.6309328,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000653.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000653.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000653",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000653",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3434267,
    "longitude": 74.6309441,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Blow-up (Buckling)",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000654.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000654.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000654",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000654",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3433976,
    "longitude": 74.6309484,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000655.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000655.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000655",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000655",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3433566,
    "longitude": 74.6309542,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000656.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000656.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000656",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000656",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3557153,
    "longitude": 74.6304409,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000667.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000667.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000667",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000667",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3557776,
    "longitude": 74.6304275,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000668.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000668.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000668",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000668",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3558397,
    "longitude": 74.6304145,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000669.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000669.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000669",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000669",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3558907,
    "longitude": 74.630407,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000670.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000670.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000670",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000670",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3559413,
    "longitude": 74.630397,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000671.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000671.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000671",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000671",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3560004,
    "longitude": 74.6303814,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000672.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000672.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000672",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000672",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3560517,
    "longitude": 74.6303669,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000673.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000673.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000673",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000673",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3561122,
    "longitude": 74.6303473,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000674.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000674.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000674",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000674",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3561693,
    "longitude": 74.6303276,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000675.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000675.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000675",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000675",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3562291,
    "longitude": 74.6303069,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000676.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000676.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000676",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000676",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3562905,
    "longitude": 74.6302814,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000677.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000677.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000677",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000677",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.356353,
    "longitude": 74.6302642,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000678.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000678.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000678",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000678",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3567377,
    "longitude": 74.6300198,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000687.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000687.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000687",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000687",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3567912,
    "longitude": 74.6300058,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000688.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000688.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000688",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000688",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3568427,
    "longitude": 74.629993,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000689.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000689.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000689",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000689",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3569057,
    "longitude": 74.6299767,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000690.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000690.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000690",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000690",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3592466,
    "longitude": 74.6299759,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000727.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000727.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000727",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000727",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3600899,
    "longitude": 74.6300806,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000745.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000745.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000745",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000745",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.36013,
    "longitude": 74.6300804,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000746.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000746.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000746",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000746",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3601696,
    "longitude": 74.6300786,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000747.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000747.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000747",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000747",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3602081,
    "longitude": 74.6300756,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000748.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000748.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000748",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000748",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3609322,
    "longitude": 74.6299225,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000762.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000762.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000762",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000762",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3610426,
    "longitude": 74.6298441,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000763.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000763.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000763",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000763",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3611081,
    "longitude": 74.6297918,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000764.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000764.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000764",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000764",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3611518,
    "longitude": 74.6297567,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000765.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000765.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000765",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000765",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3644436,
    "longitude": 74.6275223,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000822.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000822.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000822",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000822",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3647261,
    "longitude": 74.6272778,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000826.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000826.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000826",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000826",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3647788,
    "longitude": 74.6272568,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000827.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000827.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000827",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000827",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3648401,
    "longitude": 74.6272302,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000828.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000828.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000828",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000828",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3649046,
    "longitude": 74.6272049,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000829.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000829.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000829",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000829",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3498113,
    "longitude": 74.6302251,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000840.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000840.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000840",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000840",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.349933,
    "longitude": 74.6302355,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000843.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000843.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000843",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000843",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.349963,
    "longitude": 74.6302413,
    "inference_info": [
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000844.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000844.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000844",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000844",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3499917,
    "longitude": 74.6302465,
    "inference_info": [
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000845.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000845.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000845",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000845",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3500211,
    "longitude": 74.6302511,
    "inference_info": [
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000846.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000846.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000846",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000846",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3500521,
    "longitude": 74.6302566,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000847.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000847.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000847",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000847",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3500812,
    "longitude": 74.6302621,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000848.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000848.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000848",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000848",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3501215,
    "longitude": 74.6302688,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000849.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000849.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000849",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000849",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3501508,
    "longitude": 74.6302734,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000850.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000850.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000850",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000850",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3501913,
    "longitude": 74.6302791,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000851.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000851.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000851",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000851",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3502206,
    "longitude": 74.6302823,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000852.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000852.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000852",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000852",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3502609,
    "longitude": 74.6302864,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000853.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000853.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000853",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000853",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3502915,
    "longitude": 74.630289,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000854.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000854.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000854",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000854",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3503203,
    "longitude": 74.6302911,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000855.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000855.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000855",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000855",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3503502,
    "longitude": 74.6302916,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000856.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000856.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000856",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000856",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35038,
    "longitude": 74.630292,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000857.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000857.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000857",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000857",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35041,
    "longitude": 74.630292,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000858.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000858.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000858",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000858",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3504388,
    "longitude": 74.6302919,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000859.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000859.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000859",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000859",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3505878,
    "longitude": 74.6302803,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000862.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000862.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000862",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000862",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3506488,
    "longitude": 74.6302756,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000864.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000864.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000864",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000864",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3506982,
    "longitude": 74.6302724,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000865.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000865.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000865",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000865",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3508082,
    "longitude": 74.6302635,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000868.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000868.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000868",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000868",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3508385,
    "longitude": 74.6302615,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000869.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000869.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000869",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000869",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3509484,
    "longitude": 74.6302545,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000872.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000872.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000872",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000872",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3509783,
    "longitude": 74.6302523,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000873.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000873.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000873",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000873",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3510383,
    "longitude": 74.6302474,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000875.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000875.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000875",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000875",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3510781,
    "longitude": 74.6302438,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000876.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000876.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000876",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000876",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.351449,
    "longitude": 74.6302128,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000885.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000885.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000885",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000885",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.351479,
    "longitude": 74.6302114,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000886.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000886.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000886",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000886",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3515292,
    "longitude": 74.6302092,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000887.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000887.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000887",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000887",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3515597,
    "longitude": 74.6302079,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000888.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000888.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000888",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000888",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3516197,
    "longitude": 74.630207,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000889.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000889.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000889",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000889",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3516598,
    "longitude": 74.6302064,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000890.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000890.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000890",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000890",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3516907,
    "longitude": 74.6302061,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000891.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000891.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000891",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000891",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3517306,
    "longitude": 74.6302086,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000892.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000892.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000892",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000892",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3518001,
    "longitude": 74.6302196,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000893.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000893.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000893",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000893",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3518307,
    "longitude": 74.6302279,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000894.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000894.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000894",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000894",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35186,
    "longitude": 74.6302399,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Crash Barriers",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000895.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000895.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000895",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000895",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3519003,
    "longitude": 74.6302594,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000896.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000896.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000896",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000896",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3519386,
    "longitude": 74.6302827,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000897.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000897.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000897",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000897",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3519675,
    "longitude": 74.630304,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000898.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000898.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000898",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000898",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3520066,
    "longitude": 74.6303348,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000899.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000899.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000899",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000899",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3520339,
    "longitude": 74.6303586,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000900.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000900.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000900",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000900",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3520708,
    "longitude": 74.6303919,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000901.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000901.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000901",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000901",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3521073,
    "longitude": 74.6304264,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000902.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000902.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000902",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000902",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.352137,
    "longitude": 74.630456,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000903.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000903.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000903",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000903",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3521733,
    "longitude": 74.6304917,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000904.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000904.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000904",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000904",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3522143,
    "longitude": 74.6305304,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000905.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000905.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000905",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000905",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.352245,
    "longitude": 74.6305594,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000906.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000906.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000906",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000906",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3524771,
    "longitude": 74.6307614,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000912.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000912.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000912",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000912",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3525199,
    "longitude": 74.6307913,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000913.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000913.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000913",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000913",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3525509,
    "longitude": 74.6308093,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000914.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000914.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000914",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000914",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3525939,
    "longitude": 74.6308282,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000915.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000915.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000915",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000915",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3526283,
    "longitude": 74.6308394,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000916.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000916.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000916",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000916",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3526702,
    "longitude": 74.6308488,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000917.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000917.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000917",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000917",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3526996,
    "longitude": 74.6308534,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000918.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000918.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000918",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000918",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3527301,
    "longitude": 74.630858,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000919.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000919.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000919",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000919",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3527605,
    "longitude": 74.63086,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000920.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000920.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000920",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000920",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3527904,
    "longitude": 74.6308619,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000921.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000921.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000921",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000921",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3528395,
    "longitude": 74.6308604,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000922.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000922.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000922",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000922",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3528677,
    "longitude": 74.6308581,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000923.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000923.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000923",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000923",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3528973,
    "longitude": 74.6308544,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000924.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000924.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000924",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000924",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3529548,
    "longitude": 74.6308429,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000926.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000926.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000926",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000926",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3533063,
    "longitude": 74.6307823,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000936.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000936.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000936",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000936",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3533669,
    "longitude": 74.6307736,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000938.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000938.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000938",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000938",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3534369,
    "longitude": 74.6307635,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000940.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000940.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000940",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000940",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3534962,
    "longitude": 74.6307534,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000941.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000941.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000941",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000941",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3535368,
    "longitude": 74.6307465,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000942.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000942.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000942",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000942",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3535772,
    "longitude": 74.6307398,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000943.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000943.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000943",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000943",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.353608,
    "longitude": 74.6307348,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000944.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000944.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000944",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000944",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3536374,
    "longitude": 74.63073,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000945.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000945.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000945",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000945",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3536681,
    "longitude": 74.630725,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000946.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000946.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000946",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000946",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3536987,
    "longitude": 74.6307202,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000947.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000947.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000947",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000947",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3537391,
    "longitude": 74.6307138,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000948.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000948.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000948",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000948",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3537698,
    "longitude": 74.6307084,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000949.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000949.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000949",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000949",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3538088,
    "longitude": 74.6307015,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000950.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000950.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000950",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000950",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3538491,
    "longitude": 74.630694,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000951.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000951.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000951",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000951",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3538797,
    "longitude": 74.6306882,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000952.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000952.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000952",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000952",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3539087,
    "longitude": 74.6306826,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000953.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000953.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000953",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000953",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3539603,
    "longitude": 74.6306719,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000954.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000954.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000954",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000954",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3539909,
    "longitude": 74.6306655,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000955.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000955.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000955",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000955",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3540296,
    "longitude": 74.6306575,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000956.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000956.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000956",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000956",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3540602,
    "longitude": 74.6306512,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000957.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000957.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000957",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000957",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3540908,
    "longitude": 74.6306448,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000958.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000958.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000958",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000958",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3541198,
    "longitude": 74.6306388,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000959.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000959.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000959",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000959",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3541504,
    "longitude": 74.6306325,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000960.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000960.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000960",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000960",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.354181,
    "longitude": 74.6306262,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000961.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000961.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000961",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000961",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35421,
    "longitude": 74.6306203,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000962.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000962.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000962",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000962",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3542407,
    "longitude": 74.6306142,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000963.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000963.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000963",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000963",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3543004,
    "longitude": 74.6306027,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000964.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000964.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000964",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000964",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3543602,
    "longitude": 74.6305914,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000965.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000965.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000965",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000965",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3544006,
    "longitude": 74.6305838,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000966.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000966.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000966",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000966",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3544312,
    "longitude": 74.6305784,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000967.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000967.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000967",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000967",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3544605,
    "longitude": 74.6305731,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000968.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000968.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000968",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000968",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3544896,
    "longitude": 74.6305677,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000969.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000969.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000969",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000969",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.35453,
    "longitude": 74.6305597,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000970.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000970.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000970",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000970",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3545799,
    "longitude": 74.6305496,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000971.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000971.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000971",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000971",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3546202,
    "longitude": 74.6305412,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000972.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000972.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000972",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000972",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3546492,
    "longitude": 74.6305352,
    "inference_info": [
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000973.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000973.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000973",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000973",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3546783,
    "longitude": 74.6305293,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000974.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000974.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000974",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000974",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3547186,
    "longitude": 74.6305213,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Faded Painting Concrete Crash (CC) Barrier",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000975.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000975.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000975",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000975",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3547492,
    "longitude": 74.6305151,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000976.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000976.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000976",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000976",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3547798,
    "longitude": 74.6305089,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000977.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000977.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000977",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000977",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3548088,
    "longitude": 74.630503,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000978.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000978.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000978",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000978",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3548684,
    "longitude": 74.6304906,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000979.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000979.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000979",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000979",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3548978,
    "longitude": 74.6304851,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000980.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000980.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000980",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000980",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3549382,
    "longitude": 74.6304778,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000981.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000981.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000981",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000981",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3549688,
    "longitude": 74.6304722,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000982.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000982.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000982",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000982",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3550187,
    "longitude": 74.630463,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000983.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000983.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000983",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000983",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.355072,
    "longitude": 74.6304511,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000984.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000984.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000984",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000984",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3551025,
    "longitude": 74.6304447,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/000985.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000985.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000985",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000985",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3551447,
    "longitude": 74.6304358,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/000986.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000986.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000986",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000986",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3432982,
    "longitude": 74.6309628,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000987.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000987.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000987",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000987",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3432585,
    "longitude": 74.6309683,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000988.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000988.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000988",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000988",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3432182,
    "longitude": 74.6309745,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000989.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000989.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000989",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000989",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3431789,
    "longitude": 74.63098,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "high"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/000990.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000990.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000990",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000990",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3431385,
    "longitude": 74.6309852,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000991.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000991.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000991",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000991",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3431089,
    "longitude": 74.6309887,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000992.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000992.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000992",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000992",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3430692,
    "longitude": 74.6309932,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000993.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000993.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000993",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000993",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3430293,
    "longitude": 74.6309955,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000994.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000994.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000994",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000994",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3429893,
    "longitude": 74.6309984,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000995.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000995.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000995",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000995",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3429582,
    "longitude": 74.6310012,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000996.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000996.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000996",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000996",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3429285,
    "longitude": 74.6310046,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000997.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000997.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000997",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000997",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3428886,
    "longitude": 74.6310083,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/000998.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000998.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000998",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000998",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3428228,
    "longitude": 74.6310637,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/000999.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/000999.png",
    "gcs_bucket": "datanh11",
    "frame_id": "000999",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-000999",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3427786,
    "longitude": 74.6310183,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001000.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001000.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001000",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001000",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3426985,
    "longitude": 74.6310238,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001001.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001001.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001001",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001001",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3425724,
    "longitude": 74.6310968,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001003.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001003.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001003",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001003",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3424925,
    "longitude": 74.6311057,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001005.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001005.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001005",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001005",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3423739,
    "longitude": 74.6311179,
    "inference_info": [
      {
        "label": "Potholes",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001007.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001007.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001007",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001007",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3422094,
    "longitude": 74.6311445,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001010.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001010.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001010",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001010",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3421806,
    "longitude": 74.6311446,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001011.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001011.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001011",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001011",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3421403,
    "longitude": 74.6311463,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001012.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001012.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001012",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001012",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3420906,
    "longitude": 74.6311489,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "high"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001013.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001013.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001013",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001013",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3420509,
    "longitude": 74.6311523,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001014.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001014.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001014",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001014",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3420018,
    "longitude": 74.6311573,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001015.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001015.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001015",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001015",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3419722,
    "longitude": 74.6311611,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001016.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001016.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001016",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001016",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3419424,
    "longitude": 74.6311648,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001017.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001017.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001017",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001017",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3418815,
    "longitude": 74.6311715,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001018.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001018.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001018",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001018",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3418517,
    "longitude": 74.6311741,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001019.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001019.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001019",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001019",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3418219,
    "longitude": 74.6311767,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001020.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001020.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001020",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001020",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3417914,
    "longitude": 74.6311794,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001021.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001021.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001021",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001021",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3417211,
    "longitude": 74.6311855,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001022.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001022.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001022",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001022",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3416913,
    "longitude": 74.6311881,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001023.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001023.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001023",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001023",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3416317,
    "longitude": 74.6311934,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001024.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001024.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001024",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001024",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3416016,
    "longitude": 74.6311965,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001025.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001025.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001025",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001025",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.341572,
    "longitude": 74.6312001,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001026.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001026.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001026",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001026",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3415427,
    "longitude": 74.6312038,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001027.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001027.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001027",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001027",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3414826,
    "longitude": 74.6312122,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001028.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001028.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001028",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001028",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3414531,
    "longitude": 74.6312165,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001029.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001029.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001029",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001029",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.341383,
    "longitude": 74.6312263,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001030.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001030.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001030",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001030",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3412228,
    "longitude": 74.6312484,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001034.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001034.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001034",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001034",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3411733,
    "longitude": 74.6312552,
    "inference_info": [
      {
        "label": "Corner Break (Concrete)",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001035.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001035.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001035",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001035",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3411022,
    "longitude": 74.6312666,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001036.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001036.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001036",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001036",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3410718,
    "longitude": 74.6312701,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001037.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001037.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001037",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001037",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3410412,
    "longitude": 74.6312735,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001038.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001038.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001038",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001038",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3410119,
    "longitude": 74.6312772,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001039.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001039.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001039",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001039",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3409706,
    "longitude": 74.6312812,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001040.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001040.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001040",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001040",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34092,
    "longitude": 74.631284,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001041.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001041.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001041",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001041",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34089,
    "longitude": 74.631286,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001042.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001042.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001042",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001042",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3408614,
    "longitude": 74.6312863,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001043.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001043.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001043",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001043",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.340832,
    "longitude": 74.6312896,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001044.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001044.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001044",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001044",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3407821,
    "longitude": 74.631295,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001045.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001045.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001045",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001045",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3407314,
    "longitude": 74.6313031,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001046.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001046.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001046",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001046",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3406915,
    "longitude": 74.6313091,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001047.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001047.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001047",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001047",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3406624,
    "longitude": 74.6313149,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001048.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001048.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001048",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001048",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3405906,
    "longitude": 74.631325,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001049.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001049.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001049",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001049",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3405513,
    "longitude": 74.6313308,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001050.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001050.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001050",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001050",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3405108,
    "longitude": 74.6313366,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001051.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001051.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001051",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001051",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3404813,
    "longitude": 74.6313408,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001052.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001052.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001052",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001052",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3404503,
    "longitude": 74.6313439,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001053.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001053.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001053",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001053",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3404212,
    "longitude": 74.6313481,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001054.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001054.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001054",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001054",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3403697,
    "longitude": 74.6313582,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001055.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001055.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001055",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001055",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3403392,
    "longitude": 74.6313634,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001056.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001056.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001056",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001056",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3402497,
    "longitude": 74.6313779,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001057.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001057.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001057",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001057",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3402103,
    "longitude": 74.631383,
    "inference_info": [
      {
        "label": "Shoulder - Edge Drop",
        "severity": "low"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001058.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001058.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001058",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001058",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34016,
    "longitude": 74.6313881,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001059.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001059.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001059",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001059",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34011,
    "longitude": 74.6313898,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001060.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001060.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001060",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001060",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3400604,
    "longitude": 74.6313896,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001061.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001061.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001061",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001061",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3400302,
    "longitude": 74.6313886,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001062.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001062.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001062",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001062",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3399996,
    "longitude": 74.6313881,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001063.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001063.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001063",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001063",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3399293,
    "longitude": 74.6313904,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001064.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001064.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001064",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001064",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3398991,
    "longitude": 74.631392,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001065.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001065.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001065",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001065",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.339857,
    "longitude": 74.6313952,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001066.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001066.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001066",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001066",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3397787,
    "longitude": 74.6314054,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Median Openings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001067.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001067.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001067",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001067",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3397391,
    "longitude": 74.6314097,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001068.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001068.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001068",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001068",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3396982,
    "longitude": 74.6314141,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001069.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001069.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001069",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001069",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3396291,
    "longitude": 74.6314245,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001070.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001070.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001070",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001070",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3395888,
    "longitude": 74.6314325,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001071.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001071.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001071",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001071",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3395402,
    "longitude": 74.6314413,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001072.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001072.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001072",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001072",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3394604,
    "longitude": 74.6314535,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001073.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001073.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001073",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001073",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3394208,
    "longitude": 74.6314586,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001074.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001074.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001074",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001074",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3393912,
    "longitude": 74.6314622,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001075.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001075.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001075",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001075",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3393109,
    "longitude": 74.6314707,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001076.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001076.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001076",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001076",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3392303,
    "longitude": 74.6314769,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001077.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001077.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001077",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001077",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3391904,
    "longitude": 74.6314789,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001078.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001078.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001078",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001078",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3391402,
    "longitude": 74.6314831,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001079.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001079.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001079",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001079",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3390998,
    "longitude": 74.6314859,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001080.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001080.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001080",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001080",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33905,
    "longitude": 74.6314896,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001081.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001081.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001081",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001081",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3389599,
    "longitude": 74.6314981,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001082.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001082.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001082",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001082",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3389193,
    "longitude": 74.6315023,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001083.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001083.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001083",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001083",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3388698,
    "longitude": 74.6315078,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001084.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001084.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001084",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001084",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3388204,
    "longitude": 74.6315138,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001085.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001085.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001085",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001085",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33877,
    "longitude": 74.63152,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001086.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001086.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001086",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001086",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3387205,
    "longitude": 74.6315256,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001087.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001087.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001087",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001087",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3386701,
    "longitude": 74.6315309,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001088.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001088.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001088",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001088",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3385707,
    "longitude": 74.6315399,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001089.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001089.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001089",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001089",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3385202,
    "longitude": 74.6315436,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001090.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001090.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001090",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001090",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3384703,
    "longitude": 74.6315466,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001091.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001091.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001091",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001091",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3384205,
    "longitude": 74.6315496,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001092.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001092.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001092",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001092",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3383108,
    "longitude": 74.6315596,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001093.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001093.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001093",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001093",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3382603,
    "longitude": 74.6315644,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001094.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001094.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001094",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001094",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3381602,
    "longitude": 74.631573,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001095.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001095.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001095",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001095",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3381198,
    "longitude": 74.6315767,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001096.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001096.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001096",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001096",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3380701,
    "longitude": 74.631581,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001097.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001097.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001097",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001097",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3379799,
    "longitude": 74.6315889,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001098.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001098.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001098",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001098",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3379303,
    "longitude": 74.6315939,
    "inference_info": [
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001099.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001099.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001099",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001099",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3378805,
    "longitude": 74.6315983,
    "inference_info": [
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001100.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001100.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001100",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001100",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3377909,
    "longitude": 74.631605,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001101.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001101.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001101",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001101",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3377414,
    "longitude": 74.6316089,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001102.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001102.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001102",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001102",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3377017,
    "longitude": 74.6316126,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001103.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001103.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001103",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001103",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3376022,
    "longitude": 74.6316233,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001104.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001104.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001104",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001104",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3374929,
    "longitude": 74.631637,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001106.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001106.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001106",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001106",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3373824,
    "longitude": 74.6316483,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001107.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001107.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001107",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001107",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3373313,
    "longitude": 74.6316538,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001108.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001108.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001108",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001108",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.337271,
    "longitude": 74.6316608,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001109.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001109.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001109",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001109",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3371611,
    "longitude": 74.6316722,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001110.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001110.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001110",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001110",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3371008,
    "longitude": 74.6316787,
    "inference_info": [
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001111.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001111.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001111",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001111",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3370405,
    "longitude": 74.6316857,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001112.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001112.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001112",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001112",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.336931,
    "longitude": 74.6316994,
    "inference_info": [
      {
        "label": "Shoulder - Unevenness",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001113.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001113.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001113",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001113",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3368705,
    "longitude": 74.6317059,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001114.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001114.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001114",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001114",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3368208,
    "longitude": 74.6317109,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001115.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001115.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001115",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001115",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3367605,
    "longitude": 74.6317166,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001116.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001116.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001116",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001116",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3366507,
    "longitude": 74.631729,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001117.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001117.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001117",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001117",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3365911,
    "longitude": 74.6317346,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001118.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001118.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001118",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001118",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3364811,
    "longitude": 74.6317441,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001119.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001119.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001119",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001119",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3364307,
    "longitude": 74.631749,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001120.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001120.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001120",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001120",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3363813,
    "longitude": 74.6317542,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001121.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001121.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001121",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001121",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3362712,
    "longitude": 74.6317653,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001122.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001122.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001122",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001122",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.336211,
    "longitude": 74.6317715,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001123.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001123.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001123",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001123",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3361605,
    "longitude": 74.6317768,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001124.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001124.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001124",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001124",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3361002,
    "longitude": 74.6317826,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001125.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001125.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001125",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001125",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3360406,
    "longitude": 74.6317882,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001126.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001126.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001126",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001126",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3359201,
    "longitude": 74.6318007,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001127.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001127.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001127",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001127",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3358607,
    "longitude": 74.6318077,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001128.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001128.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001128",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001128",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3357409,
    "longitude": 74.6318207,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001129.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001129.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001129",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001129",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3356905,
    "longitude": 74.631826,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001130.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001130.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001130",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001130",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3356302,
    "longitude": 74.6318323,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001131.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001131.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001131",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001131",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3355706,
    "longitude": 74.6318385,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001132.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001132.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001132",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001132",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3354507,
    "longitude": 74.6318496,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001133.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001133.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001133",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001133",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3353409,
    "longitude": 74.6318604,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001134.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001134.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001134",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001134",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3352805,
    "longitude": 74.6318665,
    "inference_info": [
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001135.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001135.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001135",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001135",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3352203,
    "longitude": 74.6318728,
    "inference_info": [
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001136.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001136.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001136",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001136",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.335161,
    "longitude": 74.6318802,
    "inference_info": [
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001137.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001137.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001137",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001137",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3350508,
    "longitude": 74.6318909,
    "inference_info": [
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001138.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001138.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001138",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001138",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3349905,
    "longitude": 74.6318964,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001139.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001139.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001139",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001139",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3349302,
    "longitude": 74.6319026,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001140.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001140.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001140",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001140",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3348808,
    "longitude": 74.6319082,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001141.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001141.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001141",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001141",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3347707,
    "longitude": 74.6319197,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001142.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001142.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001142",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001142",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.334671,
    "longitude": 74.6319298,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001143.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001143.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001143",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001143",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3346215,
    "longitude": 74.6319357,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001144.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001144.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001144",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001144",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3345707,
    "longitude": 74.6319402,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001145.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001145.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001145",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001145",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3345106,
    "longitude": 74.6319444,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001146.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001146.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001146",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001146",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3344605,
    "longitude": 74.631947,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001147.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001147.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001147",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001147",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3343604,
    "longitude": 74.6319558,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001148.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001148.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001148",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001148",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3343106,
    "longitude": 74.6319597,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001149.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001149.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001149",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001149",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3342201,
    "longitude": 74.6319647,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001150.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001150.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001150",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001150",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3341699,
    "longitude": 74.6319665,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001151.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001151.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001151",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001151",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3340796,
    "longitude": 74.6319706,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001152.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001152.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001152",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001152",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3340296,
    "longitude": 74.6319745,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001153.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001153.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001153",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001153",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.333979,
    "longitude": 74.6319801,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001154.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001154.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001154",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001154",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3338891,
    "longitude": 74.6319927,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001155.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001155.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001155",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001155",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3338498,
    "longitude": 74.6319967,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001156.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001156.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001156",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001156",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3337995,
    "longitude": 74.632001,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Drain Cover Slabs",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001157.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001157.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001157",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001157",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.333709,
    "longitude": 74.6320092,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001158.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001158.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001158",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001158",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3336595,
    "longitude": 74.6320148,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001159.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001159.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001159",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001159",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.333609,
    "longitude": 74.6320213,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001160.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001160.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001160",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001160",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3334996,
    "longitude": 74.6320358,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001161.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001161.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001161",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001161",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33345,
    "longitude": 74.6320406,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001162.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001162.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001162",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001162",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3333996,
    "longitude": 74.6320453,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001163.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001163.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001163",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001163",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33335,
    "longitude": 74.6320502,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001164.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001164.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001164",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001164",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3332499,
    "longitude": 74.6320588,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001165.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001165.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001165",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001165",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3331896,
    "longitude": 74.6320651,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001166.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001166.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001166",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001166",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3330995,
    "longitude": 74.6320743,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001167.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001167.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001167",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001167",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3329996,
    "longitude": 74.6320859,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001168.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001168.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001168",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001168",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3328899,
    "longitude": 74.632099,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001169.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001169.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001169",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001169",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3328296,
    "longitude": 74.6321056,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001170.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001170.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001170",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001170",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3327801,
    "longitude": 74.632111,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001171.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001171.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001171",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001171",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3326694,
    "longitude": 74.6321232,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001172.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001172.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001172",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001172",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3325595,
    "longitude": 74.6321351,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001173.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001173.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001173",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001173",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3325091,
    "longitude": 74.6321415,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001174.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001174.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001174",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001174",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3356112,
    "longitude": 74.6317167,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001175.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001175.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001175",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001175",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3356914,
    "longitude": 74.6317099,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001176.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001176.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001176",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001176",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3357615,
    "longitude": 74.6317042,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001177.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001177.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001177",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001177",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3358322,
    "longitude": 74.6316987,
    "inference_info": [
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001178.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001178.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001178",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001178",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3360321,
    "longitude": 74.6316746,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001181.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001181.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001181",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001181",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.336093,
    "longitude": 74.6316672,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001182.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001182.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001182",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001182",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3361627,
    "longitude": 74.6316578,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001183.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001183.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001183",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001183",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3362216,
    "longitude": 74.6316508,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001184.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001184.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001184",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001184",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3363512,
    "longitude": 74.6316375,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001185.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001185.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001185",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001185",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3364113,
    "longitude": 74.6316326,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001186.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001186.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001186",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001186",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3364718,
    "longitude": 74.631628,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001187.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001187.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001187",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001187",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3365418,
    "longitude": 74.6316196,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001188.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001188.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001188",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001188",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.336601,
    "longitude": 74.6316136,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001189.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001189.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001189",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001189",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3366615,
    "longitude": 74.6316078,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001190.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001190.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001190",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001190",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.336722,
    "longitude": 74.6316011,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001191.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001191.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001191",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001191",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3367922,
    "longitude": 74.631593,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001192.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001192.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001192",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001192",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3368511,
    "longitude": 74.6315878,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001193.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001193.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001193",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001193",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3369122,
    "longitude": 74.6315814,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001194.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001194.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001194",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001194",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3369724,
    "longitude": 74.6315741,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001195.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001195.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001195",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001195",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.337102,
    "longitude": 74.6315609,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001196.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001196.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001196",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001196",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3371628,
    "longitude": 74.6315533,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001197.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001197.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001197",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001197",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.337222,
    "longitude": 74.6315451,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001198.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001198.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001198",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001198",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3372816,
    "longitude": 74.6315391,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001199.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001199.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001199",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001199",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3373422,
    "longitude": 74.6315316,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001200.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001200.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001200",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001200",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.337402,
    "longitude": 74.6315255,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001201.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001201.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001201",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001201",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3374615,
    "longitude": 74.6315198,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001202.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001202.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001202",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001202",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.337521,
    "longitude": 74.6315143,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001203.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001203.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001203",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001203",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3375811,
    "longitude": 74.6315094,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001204.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001204.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001204",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001204",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3377013,
    "longitude": 74.6315006,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001205.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001205.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001205",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001205",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3378219,
    "longitude": 74.6314887,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001206.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001206.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001206",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001206",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3379314,
    "longitude": 74.631476,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001207.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001207.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001207",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001207",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3380511,
    "longitude": 74.6314659,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001208.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001208.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001208",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001208",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3381712,
    "longitude": 74.6314609,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001209.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001209.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001209",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001209",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3382216,
    "longitude": 74.6314573,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001210.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001210.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001210",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001210",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3383417,
    "longitude": 74.6314487,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001212.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001212.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001212",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001212",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3384021,
    "longitude": 74.631443,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001213.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001213.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001213",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001213",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3384618,
    "longitude": 74.6314371,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001214.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001214.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001214",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001214",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3385214,
    "longitude": 74.6314322,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001215.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001215.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001215",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001215",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3385718,
    "longitude": 74.6314281,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001216.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001216.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001216",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001216",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3386922,
    "longitude": 74.6314192,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001218.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001218.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001218",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001218",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3388119,
    "longitude": 74.6314092,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001220.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001220.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001220",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001220",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3407519,
    "longitude": 74.6312078,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001256.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001256.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001256",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001256",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.340793,
    "longitude": 74.6312023,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001257.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001257.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001257",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001257",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3408428,
    "longitude": 74.6311947,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001258.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001258.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001258",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001258",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3408817,
    "longitude": 74.6311903,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001259.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001259.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001259",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001259",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3409209,
    "longitude": 74.6311869,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001260.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001260.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001260",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001260",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3409609,
    "longitude": 74.6311841,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001261.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001261.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001261",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001261",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.341011,
    "longitude": 74.6311794,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001262.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001262.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001262",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001262",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3410602,
    "longitude": 74.631174,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001263.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001263.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001263",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001263",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3411102,
    "longitude": 74.6311716,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001264.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001264.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001264",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001264",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3411606,
    "longitude": 74.6311692,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001265.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001265.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001265",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001265",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3412104,
    "longitude": 74.6311646,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001266.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001266.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001266",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001266",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.341261,
    "longitude": 74.6311581,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001267.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001267.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001267",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001267",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3413101,
    "longitude": 74.6311513,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001268.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001268.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001268",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001268",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3413605,
    "longitude": 74.6311457,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      },
      {
        "label": "Cracking",
        "severity": "medium"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001269.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001269.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001269",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001269",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3414107,
    "longitude": 74.6311409,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001270.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001270.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001270",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001270",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3414612,
    "longitude": 74.6311367,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001271.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001271.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001271",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001271",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3415013,
    "longitude": 74.6311329,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001272.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001272.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001272",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001272",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3415511,
    "longitude": 74.6311272,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001273.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001273.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001273",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001273",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.341601,
    "longitude": 74.631123,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001274.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001274.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001274",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001274",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3416506,
    "longitude": 74.6311183,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001275.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001275.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001275",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001275",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3417011,
    "longitude": 74.6311135,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001276.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001276.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001276",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001276",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3417606,
    "longitude": 74.6311078,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001277.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001277.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001277",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001277",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3418111,
    "longitude": 74.6311027,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001278.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001278.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001278",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001278",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3418516,
    "longitude": 74.6310985,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001279.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001279.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001279",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001279",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3419012,
    "longitude": 74.6310932,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001280.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001280.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001280",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001280",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3419513,
    "longitude": 74.6310881,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001281.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001281.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001281",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001281",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3419929,
    "longitude": 74.631084,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001282.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001282.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001282",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001282",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.342033,
    "longitude": 74.631078,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001283.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001283.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001283",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001283",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3420819,
    "longitude": 74.6310717,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001284.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001284.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001284",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001284",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3421224,
    "longitude": 74.6310674,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001285.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001285.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001285",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001285",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3422021,
    "longitude": 74.6310595,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001287.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001287.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001287",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001287",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3422519,
    "longitude": 74.631055,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001288.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001288.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001288",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001288",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3422919,
    "longitude": 74.6310508,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001289.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001289.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001289",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001289",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3423424,
    "longitude": 74.6310449,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001290.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001290.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001290",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001290",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3423825,
    "longitude": 74.6310387,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001291.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001291.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001291",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001291",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3424311,
    "longitude": 74.6310321,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001292.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001292.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001292",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001292",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3424812,
    "longitude": 74.631027,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001293.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001293.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001293",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001293",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3425207,
    "longitude": 74.6310243,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001294.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001294.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001294",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001294",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3425684,
    "longitude": 74.6310256,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001295.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001295.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001295",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001295",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.342872,
    "longitude": 74.6310097,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "high"
      }
    ],
    "defect_state": "high",
    "og_file": "bhilwara_rotated_frames_post_new/001298.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001298.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001298",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001298",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3429719,
    "longitude": 74.6309997,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "medium"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001300.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001300.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001300",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001300",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3433337,
    "longitude": 74.6309579,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001307.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001307.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001307",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001307",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3434736,
    "longitude": 74.6309366,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001309.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001309.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001309",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001309",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3435127,
    "longitude": 74.6309301,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001310.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001310.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001310",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001310",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3435517,
    "longitude": 74.6309241,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001311.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001311.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001311",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001311",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3435922,
    "longitude": 74.630918,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001312.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001312.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001312",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001312",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3436216,
    "longitude": 74.6309139,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001313.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001313.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001313",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001313",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3436728,
    "longitude": 74.6309074,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001314.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001314.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001314",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001314",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3437009,
    "longitude": 74.630903,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001315.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001315.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001315",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001315",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3437343,
    "longitude": 74.630904,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001316.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001316.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001316",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001316",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.343812,
    "longitude": 74.630909,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001318.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001318.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001318",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001318",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3438631,
    "longitude": 74.630905,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001319.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001319.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001319",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001319",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3439808,
    "longitude": 74.630887,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001321.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001321.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001321",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001321",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3440202,
    "longitude": 74.6308815,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001322.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001322.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001322",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001322",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3440497,
    "longitude": 74.6308776,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001323.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001323.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001323",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001323",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3441002,
    "longitude": 74.6308721,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001324.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001324.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001324",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001324",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3441498,
    "longitude": 74.6308675,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001325.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001325.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001325",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001325",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3441804,
    "longitude": 74.6308648,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001326.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001326.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001326",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001326",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34423,
    "longitude": 74.6308599,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001327.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001327.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001327",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001327",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3442606,
    "longitude": 74.6308559,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001328.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001328.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001328",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001328",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3442908,
    "longitude": 74.6308528,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001329.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001329.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001329",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001329",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3443207,
    "longitude": 74.6308506,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001330.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001330.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001330",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001330",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3443505,
    "longitude": 74.6308482,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001331.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001331.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001331",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001331",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3443835,
    "longitude": 74.630844,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001332.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001332.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001332",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001332",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3444114,
    "longitude": 74.6308354,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001333.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001333.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001333",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001333",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3444413,
    "longitude": 74.6308293,
    "inference_info": [
      {
        "label": "Illegal Parking",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001334.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001334.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001334",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001334",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3444708,
    "longitude": 74.6308261,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001335.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001335.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001335",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001335",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3445004,
    "longitude": 74.6308247,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001336.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001336.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001336",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001336",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.34453,
    "longitude": 74.630824,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001337.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001337.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001337",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001337",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3445618,
    "longitude": 74.6308233,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001338.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001338.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001338",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001338",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3450125,
    "longitude": 74.630775,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001346.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001346.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001346",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001346",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3452422,
    "longitude": 74.6307471,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001349.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001349.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001349",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001349",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.345272,
    "longitude": 74.6307441,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001350.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001350.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001350",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001350",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3461546,
    "longitude": 74.6306109,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001369.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001369.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001369",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001369",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3461938,
    "longitude": 74.6306017,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001370.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001370.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001370",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001370",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3462334,
    "longitude": 74.6305935,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001371.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001371.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001371",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001371",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.346282,
    "longitude": 74.630585,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001372.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001372.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001372",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001372",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3463211,
    "longitude": 74.6305796,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001373.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001373.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001373",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001373",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3463714,
    "longitude": 74.6305728,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001374.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001374.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001374",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001374",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3464207,
    "longitude": 74.6305664,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001375.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001375.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001375",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001375",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3464612,
    "longitude": 74.6305614,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001376.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001376.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001376",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001376",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3465114,
    "longitude": 74.6305557,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001377.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001377.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001377",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001377",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3465621,
    "longitude": 74.6305495,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001378.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001378.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001378",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001378",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3466113,
    "longitude": 74.6305434,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001379.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001379.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001379",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001379",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3466614,
    "longitude": 74.6305379,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001380.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001380.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001380",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001380",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.346711,
    "longitude": 74.6305332,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001381.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001381.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001381",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001381",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3467616,
    "longitude": 74.6305277,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001382.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001382.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001382",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001382",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3468021,
    "longitude": 74.6305232,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001383.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001383.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001383",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001383",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3468518,
    "longitude": 74.6305175,
    "inference_info": [
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001384.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001384.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001384",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001384",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3469022,
    "longitude": 74.6305111,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Patching",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001385.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001385.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001385",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001385",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3469514,
    "longitude": 74.6305054,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001386.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001386.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001386",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001386",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3470014,
    "longitude": 74.6305008,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001387.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001387.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001387",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001387",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3470416,
    "longitude": 74.6304969,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001388.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001388.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001388",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001388",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3470821,
    "longitude": 74.6304923,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001389.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001389.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001389",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001389",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3471118,
    "longitude": 74.6304888,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001390.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001390.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001390",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001390",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3471413,
    "longitude": 74.6304857,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Damaged Road Studs",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001391.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001391.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001391",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001391",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3471817,
    "longitude": 74.6304817,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001392.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001392.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001392",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001392",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3472118,
    "longitude": 74.6304785,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001393.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001393.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001393",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001393",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3472434,
    "longitude": 74.6304746,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001394.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001394.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001394",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001394",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3472825,
    "longitude": 74.6304679,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001395.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001395.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001395",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001395",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3473132,
    "longitude": 74.6304627,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001396.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001396.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001396",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001396",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3473521,
    "longitude": 74.6304551,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001397.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001397.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001397",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001397",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3473912,
    "longitude": 74.6304484,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001398.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001398.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001398",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001398",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3474296,
    "longitude": 74.6304456,
    "inference_info": [
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001399.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001399.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001399",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001399",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3474707,
    "longitude": 74.6304445,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001400.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001400.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001400",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001400",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3475109,
    "longitude": 74.6304424,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001401.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001401.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001401",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001401",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3475604,
    "longitude": 74.6304409,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001402.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001402.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001402",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001402",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3476096,
    "longitude": 74.6304404,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Sign Boards / Sign Structures",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001403.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001403.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001403",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001403",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3477115,
    "longitude": 74.6304374,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001405.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001405.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001405",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001405",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3480935,
    "longitude": 74.6304221,
    "inference_info": [
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001411.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001411.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001411",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001411",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3481444,
    "longitude": 74.6304114,
    "inference_info": [],
    "defect_state": "",
    "og_file": "bhilwara_rotated_frames_post_new/001412.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001412.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001412",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001412",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3481918,
    "longitude": 74.6304003,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001413.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001413.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001413",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001413",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3482398,
    "longitude": 74.6303892,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001414.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001414.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001414",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001414",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3482894,
    "longitude": 74.6303771,
    "inference_info": [
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001415.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001415.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001415",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001415",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3483457,
    "longitude": 74.6303615,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001416.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001416.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001416",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001416",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3323995,
    "longitude": 74.6321531,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Cracking",
        "severity": "low"
      },
      {
        "label": "Cracking",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001443.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001443.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001443",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001443",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.332349,
    "longitude": 74.6321579,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001444.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001444.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001444",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001444",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3322388,
    "longitude": 74.6321678,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001445.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001445.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001445",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001445",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3321894,
    "longitude": 74.6321735,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001446.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001446.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001446",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001446",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3321292,
    "longitude": 74.63218,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001447.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001447.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001447",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001447",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3320193,
    "longitude": 74.6321922,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001448.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001448.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001448",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001448",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3319698,
    "longitude": 74.6321978,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001449.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001449.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001449",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001449",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3319095,
    "longitude": 74.6322047,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001450.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001450.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001450",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001450",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.331789,
    "longitude": 74.632219,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001451.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001451.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001451",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001451",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3317395,
    "longitude": 74.6322246,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001452.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001452.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001452",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001452",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3316792,
    "longitude": 74.6322317,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Pavement Damage",
        "severity": "low"
      },
      {
        "label": "Pavement Damage",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001453.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001453.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001453",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001453",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3315597,
    "longitude": 74.6322462,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001454.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001454.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001454",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001454",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3314994,
    "longitude": 74.6322524,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001455.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001455.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001455",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001455",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3314399,
    "longitude": 74.6322584,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001456.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001456.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001456",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001456",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33132,
    "longitude": 74.6322703,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001457.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001457.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001457",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001457",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3311902,
    "longitude": 74.6322827,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001458.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001458.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001458",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001458",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3310695,
    "longitude": 74.6322936,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001459.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001459.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001459",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001459",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3310191,
    "longitude": 74.6322984,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001460.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001460.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001460",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001460",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3309595,
    "longitude": 74.632304,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001461.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001461.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001461",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001461",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3308487,
    "longitude": 74.6323164,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001462.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001462.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001462",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001462",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3307392,
    "longitude": 74.6323309,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001463.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001463.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001463",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001463",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3306888,
    "longitude": 74.6323361,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001464.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001464.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001464",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001464",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3306393,
    "longitude": 74.6323411,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001465.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001465.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001465",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001465",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3305293,
    "longitude": 74.6323514,
    "inference_info": [
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001466.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001466.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001466",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001466",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3304293,
    "longitude": 74.6323605,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001467.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001467.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001467",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001467",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3303697,
    "longitude": 74.6323656,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001468.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001468.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001468",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001468",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3303093,
    "longitude": 74.6323708,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001469.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001469.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001469",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001469",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3302596,
    "longitude": 74.6323754,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001470.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001470.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001470",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001470",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3302092,
    "longitude": 74.6323805,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001471.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001471.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001471",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001471",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.330149,
    "longitude": 74.6323862,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001472.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001472.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001472",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001472",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3300993,
    "longitude": 74.6323908,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001473.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001473.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001473",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001473",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3299892,
    "longitude": 74.6324017,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001474.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001474.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001474",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001474",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3299388,
    "longitude": 74.6324077,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001475.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001475.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001475",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001475",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3298292,
    "longitude": 74.6324203,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001476.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001476.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001476",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001476",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3297193,
    "longitude": 74.6324315,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001477.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001477.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001477",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001477",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3296598,
    "longitude": 74.6324374,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001478.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001478.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001478",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001478",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3295391,
    "longitude": 74.6324481,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001479.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001479.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001479",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001479",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3294795,
    "longitude": 74.6324536,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001480.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001480.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001480",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001480",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3294291,
    "longitude": 74.6324584,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001481.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001481.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001481",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001481",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3293686,
    "longitude": 74.6324643,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001482.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001482.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001482",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001482",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3293191,
    "longitude": 74.6324695,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001483.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001483.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001483",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001483",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3292696,
    "longitude": 74.6324747,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001484.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001484.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001484",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001484",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3292092,
    "longitude": 74.6324809,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001485.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001485.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001485",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001485",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3291101,
    "longitude": 74.6324912,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001486.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001486.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001486",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001486",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3290498,
    "longitude": 74.6324975,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001487.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001487.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001487",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001487",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3290002,
    "longitude": 74.6325028,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001488.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001488.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001488",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001488",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3289399,
    "longitude": 74.6325087,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001489.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001489.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001489",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001489",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3288299,
    "longitude": 74.6325194,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001490.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001490.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001490",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001490",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3287795,
    "longitude": 74.6325246,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001491.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001491.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001491",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001491",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3287192,
    "longitude": 74.6325311,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001492.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001492.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001492",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001492",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3286598,
    "longitude": 74.6325373,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001493.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001493.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001493",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001493",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3285498,
    "longitude": 74.6325479,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001494.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001494.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001494",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001494",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3284895,
    "longitude": 74.6325534,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001495.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001495.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001495",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001495",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3284398,
    "longitude": 74.6325579,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001496.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001496.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001496",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001496",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3283299,
    "longitude": 74.6325688,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001497.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001497.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001497",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001497",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.32822,
    "longitude": 74.6325796,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001498.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001498.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001498",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001498",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3281696,
    "longitude": 74.6325845,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001499.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001499.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001499",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001499",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3281199,
    "longitude": 74.6325893,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001500.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001500.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001500",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001500",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3280596,
    "longitude": 74.6325951,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001501.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001501.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001501",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001501",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3280091,
    "longitude": 74.6326,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001502.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001502.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001502",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001502",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3279497,
    "longitude": 74.6326063,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      },
      {
        "label": "Shoulder - Vegetation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001503.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001503.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001503",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001503",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3279603,
    "longitude": 74.6324734,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001504.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001504.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001504",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001504",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3280206,
    "longitude": 74.6324673,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001505.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001505.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001505",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001505",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3280909,
    "longitude": 74.6324607,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001506.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001506.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001506",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001506",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3281611,
    "longitude": 74.6324535,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001507.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001507.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001507",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001507",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3282305,
    "longitude": 74.6324464,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001508.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001508.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001508",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001508",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3283014,
    "longitude": 74.6324393,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001509.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001509.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001509",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001509",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.328361,
    "longitude": 74.6324339,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001510.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001510.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001510",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001510",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3284313,
    "longitude": 74.6324276,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001511.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001511.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001511",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001511",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3285017,
    "longitude": 74.632421,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001512.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001512.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001512",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001512",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3285712,
    "longitude": 74.6324141,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001513.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001513.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001513",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001513",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3286315,
    "longitude": 74.6324079,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001514.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001514.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001514",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001514",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3286915,
    "longitude": 74.632402,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001515.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001515.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001515",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001515",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3287512,
    "longitude": 74.632397,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001516.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001516.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001516",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001516",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3288117,
    "longitude": 74.6323914,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001517.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001517.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001517",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001517",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3288713,
    "longitude": 74.6323857,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001518.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001518.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001518",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001518",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3289415,
    "longitude": 74.6323787,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001519.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001519.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001519",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001519",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.329011,
    "longitude": 74.6323717,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001520.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001520.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001520",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001520",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3290811,
    "longitude": 74.632365,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001521.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001521.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001521",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001521",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3291507,
    "longitude": 74.6323583,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001522.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001522.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001522",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001522",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3292308,
    "longitude": 74.63235,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001523.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001523.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001523",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001523",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3293003,
    "longitude": 74.6323433,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001524.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001524.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001524",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001524",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3293804,
    "longitude": 74.6323354,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001525.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001525.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001525",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001525",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3294599,
    "longitude": 74.6323284,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001526.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001526.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001526",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001526",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3295302,
    "longitude": 74.6323229,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001527.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001527.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001527",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001527",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3296104,
    "longitude": 74.6323168,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001528.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001528.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001528",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001528",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3296808,
    "longitude": 74.6323101,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001529.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001529.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001529",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001529",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3297511,
    "longitude": 74.6323026,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001530.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001530.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001530",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001530",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3298311,
    "longitude": 74.6322945,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001531.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001531.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001531",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001531",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3299125,
    "longitude": 74.6322856,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001532.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001532.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001532",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001532",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3299824,
    "longitude": 74.6322777,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001533.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001533.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001533",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001533",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3300628,
    "longitude": 74.6322688,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001534.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001534.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001534",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001534",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3302118,
    "longitude": 74.6322533,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001536.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001536.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001536",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001536",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.330292,
    "longitude": 74.6322456,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001537.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001537.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001537",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001537",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3303719,
    "longitude": 74.6322379,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001538.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001538.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001538",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001538",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3304415,
    "longitude": 74.632232,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001539.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001539.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001539",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001539",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3305216,
    "longitude": 74.6322259,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001540.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001540.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001540",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001540",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3305926,
    "longitude": 74.6322186,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001541.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001541.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001541",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001541",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3308123,
    "longitude": 74.6321986,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001544.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001544.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001544",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001544",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3310125,
    "longitude": 74.6321781,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "medium"
      }
    ],
    "defect_state": "medium",
    "og_file": "bhilwara_rotated_frames_post_new/001547.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001547.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001547",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001547",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3311324,
    "longitude": 74.6321658,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001549.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001549.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001549",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001549",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3311927,
    "longitude": 74.632159,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001550.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001550.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001550",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001550",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3313821,
    "longitude": 74.6321397,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001553.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001553.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001553",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001553",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3315023,
    "longitude": 74.6321284,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001555.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001555.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001555",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001555",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3317023,
    "longitude": 74.6321053,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001558.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001558.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001558",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001558",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3317626,
    "longitude": 74.6320986,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001559.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001559.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001559",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001559",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3318922,
    "longitude": 74.6320842,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001561.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001561.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001561",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001561",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3319622,
    "longitude": 74.632077,
    "inference_info": [
      {
        "label": "Damaged Footpath Tiles / Paver Blocks",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001562.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001562.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001562",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001562",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3320327,
    "longitude": 74.6320696,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001563.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001563.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001563",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001563",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3320919,
    "longitude": 74.6320633,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Manhole Cover",
        "severity": "low"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "low",
    "og_file": "bhilwara_rotated_frames_post_new/001564.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001564.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001564",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001564",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3321622,
    "longitude": 74.6320564,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001565.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001565.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001565",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001565",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3323518,
    "longitude": 74.6320392,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001568.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001568.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001568",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001568",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3327619,
    "longitude": 74.631999,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Illegal Parking",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001574.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001574.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001574",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001574",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.332892,
    "longitude": 74.6319864,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001576.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001576.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001576",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001576",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3331222,
    "longitude": 74.6319653,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001580.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001580.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001580",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001580",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3331819,
    "longitude": 74.6319594,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001581.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001581.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001581",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001581",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3332922,
    "longitude": 74.6319491,
    "inference_info": [
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001583.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001583.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001583",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001583",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3338518,
    "longitude": 74.6318892,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001593.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001593.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001593",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001593",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3339624,
    "longitude": 74.631877,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001595.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001595.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001595",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001595",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3340724,
    "longitude": 74.6318639,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001597.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001597.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001597",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001597",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3341234,
    "longitude": 74.631856,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001598.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001598.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001598",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001598",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3341722,
    "longitude": 74.6318484,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001599.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001599.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001599",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001599",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3342312,
    "longitude": 74.6318398,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001600.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001600.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001600",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001600",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3342913,
    "longitude": 74.6318306,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001601.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001601.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001601",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001601",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3343404,
    "longitude": 74.6318242,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001602.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001602.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001602",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001602",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3344105,
    "longitude": 74.6318163,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001603.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001603.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001603",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001603",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33447,
    "longitude": 74.63181,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001604.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001604.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001604",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001604",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3345302,
    "longitude": 74.6318021,
    "inference_info": [
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001605.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001605.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001605",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001605",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3345897,
    "longitude": 74.6317965,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Debris)",
        "severity": "none"
      },
      {
        "label": "Cleanliness (Litter)",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001606.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001606.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001606",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001606",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3346601,
    "longitude": 74.6317914,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Kerb Painting",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001607.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001607.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001607",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001607",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3347199,
    "longitude": 74.631788,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001608.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001608.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001608",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001608",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3347902,
    "longitude": 74.6317844,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001609.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001609.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001609",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001609",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.33486,
    "longitude": 74.63178,
    "inference_info": [
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001610.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001610.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001610",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001610",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.334939,
    "longitude": 74.631775,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001611.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001611.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001611",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001611",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3350101,
    "longitude": 74.6317714,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001612.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001612.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001612",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001612",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3350804,
    "longitude": 74.631767,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001613.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001613.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001613",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001613",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3351501,
    "longitude": 74.6317612,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001614.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001614.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001614",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001614",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3352302,
    "longitude": 74.6317521,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001615.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001615.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001615",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001615",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3353004,
    "longitude": 74.6317438,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "General Encroachments",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001616.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001616.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001616",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001616",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3353804,
    "longitude": 74.6317365,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Unauthorized Hoardings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001617.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001617.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001617",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001617",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3354508,
    "longitude": 74.6317302,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001618.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001618.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001618",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001618",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  },
  {
    "latitude": 25.3355308,
    "longitude": 74.6317232,
    "inference_info": [
      {
        "label": "Excessive Plantation Growth",
        "severity": "none"
      },
      {
        "label": "Damaged Kerb",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      },
      {
        "label": "Faded Pavement Markings",
        "severity": "none"
      }
    ],
    "defect_state": "none",
    "og_file": "bhilwara_rotated_frames_post_new/001619.png",
    "ai_file": "bhilwara_rotated_frames_post_new_post_annotated/001619.png",
    "gcs_bucket": "datanh11",
    "frame_id": "001619",
    "CODEBUILD_BUILD_ID": "bhilwara",
    "NEW_CODEBUILD_BUILD_ID": "bhilwara",
    "created": "2026-04-16T10:46:00.000Z",
    "road_id": "bhilwara_sukhadia_to_sanwaria",
    "project_title_display": "Bhilwara — Sukhadia Circle to Sanwaria Seth",
    "uid": "bhilwara-001619",
    "road_rating": 0,
    "_ward": "Bhilwara",
    "isvisible": true
  }
];

export default BHILWARA_DEFECT_POINTS;
